import { render, staticRenderFns } from "./SidebarNavLink.vue?vue&type=template&id=5e590946"
import script from "./SidebarNavLink.vue?vue&type=script&lang=js"
export * from "./SidebarNavLink.vue?vue&type=script&lang=js"
import style0 from "./SidebarNavLink.vue?vue&type=style&index=0&id=5e590946&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports